'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$38() {
  this.az0 = null;
  this.ayY = null;
  this.ayZ = false;
  this.ayW = null;
  this.ayX = false;
  this.az1 = false;
  this.az2 = false;
  this.az0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$38 as $c_Lpresto_AgentView$$anon$38 };
$p = $c_Lpresto_AgentView$$anon$38.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$38;
/** @constructor */
function $h_Lpresto_AgentView$$anon$38() {
}
export { $h_Lpresto_AgentView$$anon$38 as $h_Lpresto_AgentView$$anon$38 };
$h_Lpresto_AgentView$$anon$38.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.az0;
});
$p.t = (function() {
  if ((!this.ayZ)) {
    this.ayY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayZ = true;
  }
  return this.ayY;
});
$p.ad = (function() {
  if ((!this.ayX)) {
    this.ayW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nP(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ayX = true;
  }
  return this.ayW;
});
$p.v = (function() {
  if ((!this.az2)) {
    this.az1 = false;
    this.az2 = true;
  }
  return this.az1;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$38 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$38, "presto.AgentView$$anon$38", ({
  E0: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$38 as $d_Lpresto_AgentView$$anon$38 };
//# sourceMappingURL=presto.-Agent-View$$anon$38.js.map
